module.exports = __webpack_public_path__ + "static/media/AM_SZ.37800cfb.jpg";